export default __webpack_public_path__ + "static/media/dancing.ebc96f38.gif";